/* generated by tpl.py, DO NOT edit */
/* jshint -W004 */
/* jshint -W053 */
/* global exports */
var _tpl__feedbackTpl = {
    item_quality: _tpl__feedbackQuality,
    categories: _tpl__feedbackCategories,
    sub_categories: _tpl__feedbackCategories,
    keywords: _tpl__feedbackKeywords,
    source: _tpl__feedbackSource
}, _tpl__feedbackShowArr = [ "categories", "sub_categories", "item_quality", "keywords", "source" ], _tpl__feedbackSecondArr = [ "item_quality", "keywords" ], _tpl__feedbackAdList = [ "不感兴趣", "出现过于频繁", "内容质量差" ], _tpl__feedbackDefaultList = [ "标题党", "低俗", "推荐重复", "垃圾内容" ];

function _tpl__feedbackReasonCheck(item) {
    window.frames["mi-detail__iframe"].postMessage({
        order: "realTimeUpload",
        param: {
            key: "第三方组件负反馈字段下发出错",
            value: {
                id: item.docid,
                reasons: item.reasons
            }
        }
    }, "*");
    return "";
}

/* exported tpl__feedbackContent */
function tpl__feedbackContent(data) {
    var __out = "";
    var feedback = data.reasons || {}, dislike = feedback.item_quality && feedback.item_quality.length, isAd = data.isAd, tpl;
    // sub_categories 和 categories 同时存在，显示一条
    if (feedback.sub_categories && feedback.sub_categories.length) {
        feedback.categories = [];
    }
    if (isAd) {
        __out += _tpl__feedbackDefault(_tpl__feedbackAdList, isAd);
    } else if (!dislike) {
        __out += _tpl__feedbackDefault(_tpl__feedbackDefaultList);
    } else {
        __out += '<div class="mi-detail__feedback-first">';
        var __arr1 = _tpl__feedbackShowArr;
        var item, __i1 = -1, __l1 = __arr1.length - 1;
        while (__i1 < __l1) {
            item = __arr1[++__i1];
            tpl = _tpl__feedbackTpl[item];
            if (feedback[item] && feedback[item].length) {
                __out += '<div class="mi-detail__feedback-item">' + tpl(feedback[item], item, data) + "</div>";
            }
        }
        __out += "</div>";
        var __arr2 = _tpl__feedbackSecondArr;
        var item, __i2 = -1, __l2 = __arr2.length - 1;
        while (__i2 < __l2) {
            item = __arr2[++__i2];
            if (feedback[item] && feedback[item].length) {
                __out += _tpl__feedbackSecond(item, feedback[item], data);
            }
        }
    }
    return __out;
}

/* exported _tpl__feedbackQuality */
function _tpl__feedbackQuality() {
    return '<div class="mi-detail__feedback-quality"><div class="mi-detail__feedback-tab"><i></i></div>' + _tpl__feedbackLine("反馈：垃圾内容", "标题党，低俗等") + "</div>";
}

/* exported _tpl__feedbackCategories */
function _tpl__feedbackCategories(arr, type, data) {
    var __out = "";
    var item = arr[0];
    __out += '<a href="javascript:" class="mi-detail__feedback-categories';
    if (type == "sub_categories") {
        __out += " mi-detail__feedback-categories_sub";
    }
    __out += '">';
    if (item && item.length <= 6) {
        __out += _tpl__feedbackLine("不感兴趣", "减少此类内容");
    } else if (!item) {
        __out += _tpl__feedbackReasonCheck(data);
    }
    __out += "</a>";
    return __out;
}

/* exported _tpl__feedbackKeywords */
function _tpl__feedbackKeywords(arr) {
    var __out = "";
    var head, desc, postfix;
    head = arr.slice(0, 2);
    // 总字数大于8时只显示一个
    if (head.length === 2 && head[0].length + head[1].length > 8) {
        head.pop();
    }
    postfix = head.length && head.length < arr.length ? "等" : "";
    desc = head.join("，") + postfix;
    __out += '<div class="mi-detail__feedback-keywords"><div class="mi-detail__feedback-tab"><i></i></div>' + _tpl__feedbackLine("屏蔽关键字", desc) + "</div>";
    return __out;
}

/* exported _tpl__feedbackSource */
function _tpl__feedbackSource(source) {
    var __out = '<a href="javascript:" class="mi-detail__feedback-source">';
    if (source && source.length <= 7) {
        __out += _tpl__feedbackLine("拉黑作者：" + source);
    } else if (source) {
        __out += _tpl__feedbackLine("拉黑该作者");
    }
    __out += "</a>";
    return __out;
}

/* exported _tpl__feedbackLine */
function _tpl__feedbackLine(text, hint) {
    var __out = '<div class="mi-detail__feedback-line';
    if (!hint) {
        __out += " mi-detail__feedback-line_single";
    }
    __out += '"><div class="mi-detail__feedback-text">' + text + "</div>";
    if (hint) {
        __out += '<div class="mi-detail__feedback-hint">' + hint + "</div>";
    }
    __out += "</div>";
    return __out;
}

/* exported _tpl__feedbackSecond */
function _tpl__feedbackSecond(type, arr, data) {
    var __out = '<div class="mi-detail__feedback-second mi-detail__feedback-second_' + type + '"><div class="mi-detail__feedback-tab-return"><i></i>返回</div>';
    var __arr3 = arr;
    var item, index = -1, __l3 = __arr3.length - 1;
    while (index < __l3) {
        item = __arr3[++index];
        if (item && index < 4) {
            __out += '<a href="javascript:" class="mi-detail__feedback-btn mi-detail__feedback-btn_' + type + '">';
            if (type === "keywords") {
                __out += "屏蔽：";
            }
            __out += item + "</a>";
        } else if (!item) {
            __out += _tpl__feedbackReasonCheck(data);
        }
    }
    __out += "</div>";
    return __out;
}

/* exported _tpl__feedbackDefault */
function _tpl__feedbackDefault(reasons, isAd) {
    var __out = '<div class="mi-detail__feedback-first">';
    var __arr4 = reasons;
    var item, __i4 = -1, __l4 = __arr4.length - 1;
    while (__i4 < __l4) {
        item = __arr4[++__i4];
        __out += '<div class="mi-detail__feedback-item"><a href="javascript:" class="';
        if (isAd) {
            __out += "mi-detail__feedback-ad";
        }
        __out += '">' + _tpl__feedbackLine(item) + "</a></div>";
    }
    __out += "</div>";
    return __out;
}

exports.tpl__feedbackContent = tpl__feedbackContent;
